import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { format_price, format_date } from '../../functions/functions_formatting.js';


export default class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            view: "sales", // sales or payouts
            trips: [],
            sales: [],
            payouts: [],
            balance: null,
            earnings_total: null,
            payouts_total: null,
            number_purchases: null,
            number_trips: null,
            number_trip_views: null,
            average_ratings: null
        };
    }


    componentDidMount() {
        this.updateData();
    }


    componentDidUpdate() {
        this.updateData();
    }


    updateData() {
        if (this.props.trips != this.state.trips || this.props.sales != this.state.sales || this.props.payouts != this.state.payouts) {
            // Calculate data
            var number_trip_views = 0;
            var earnings_total = 0;
            var payouts_total = 0;
            const trips = this.props.trips;
            trips.forEach((trip) => {
                number_trip_views += parseInt(trip.views)
            });
            const sales = this.props.sales;
            sales.forEach((sale) => {
                earnings_total += parseFloat(sale.amount_net);
            });
            const payouts = this.props.payouts;
            payouts.forEach((payout) => {
                payouts_total += parseFloat(payout.amount);
            });

            // Update state
            this.setState({
                trips: this.props.trips,
                sales: this.props.sales,
                payouts: this.props.payouts,
                balance: earnings_total - payouts_total,
                earnings_total: earnings_total,
                payouts_total: payouts_total,
                number_purchases: this.props.sales.length,
                number_trips: this.props.trips.length,
                number_trip_views: parseInt(number_trip_views),
                average_ratings: null
            });
        }
    }


    setView(view) {
        this.setState({
            view: view
        });
    }


    render() {

        return (
            <div className="account__section">
                <div className="account__element account__dashboard__panels-container">

                    <div className="account__dashboard__panels__panel">
                        <div className="account__dashboard__panels__panel__label">
                            Current balance
                        </div>
                        <div className="account__dashboard__panels__panel__value text-subtitle text-bold">
                            {(this.props.current_balance && this.props.current_balance >= 0) ? format_price(this.props.current_balance) : format_price(0)}
                        </div>
                    </div>

                    <div className="account__dashboard__panels__panel">
                        <div className="account__dashboard__panels__panel__label">
                            Total earnings
                        </div>
                        <div className="account__dashboard__panels__panel__value text-subtitle text-bold">
                            {(this.state.earnings_total && this.state.earnings_total >= 0) ? format_price(this.state.earnings_total) : format_price(0)}
                        </div>
                    </div>

                    <div className="account__dashboard__panels__panel">
                        <div className="account__dashboard__panels__panel__label">
                            Number of unlocks/purchases
                        </div>
                        <div className="account__dashboard__panels__panel__value text-subtitle text-bold">
                            {this.state.number_purchases}
                        </div>
                    </div>

                    <div className="account__dashboard__panels__panel">
                        <div className="account__dashboard__panels__panel__label">
                            Number of trips
                        </div>
                        <div className="account__dashboard__panels__panel__value text-subtitle text-bold">
                            {this.state.number_trips}
                        </div>
                    </div>

                    <div className="account__dashboard__panels__panel">
                        <div className="account__dashboard__panels__panel__label">
                            Number of trip views
                        </div>
                        <div className="account__dashboard__panels__panel__value text-subtitle text-bold">
                            {this.state.number_trip_views}
                        </div>
                    </div>

                    {this.state.average_ratings &&
                        <div className="account__dashboard__panels__panel">
                            <div className="account__dashboard__panels__panel__label">
                                Average trip reviews
                            </div>
                            <div className="account__dashboard__panels__panel__value text-subtitle text-bold">
                                {this.state.average_ratings}
                            </div>
                        </div>
                    }

                </div>

                <div className="account__element">
                    Your current balance is paid out to you <span className="text-bold text-color-primary">every month</span>{". In case of any issues or questions, please "}
                    <Link to={"contact"} className="text-color-primary text-bold">
                        contact us
                    </Link>
                    .
                </div>

                <div className="account__element account__element__buttonbox">
                    <div onClick={() => this.setView("sales")} className={"button " + (this.state.view === "sales" ? "button-primary" : "button-primary-light")}>
                        Sales
                    </div>
                    <div onClick={() => this.setView("payouts")} className={"button " + (this.state.view === "payouts" ? "button-primary" : "button-primary-light")}>
                        Payouts
                    </div>
                </div>

                {this.state.view === "sales" &&
                    <div className="account__element account__element__saleslist">
                        <div className="account__element__saleslist__label">
                            ID
                        </div>
                        <div className="account__element__saleslist__label">
                            Date
                        </div>
                        <div className="account__element__saleslist__label">
                            Trip
                        </div>
                        <div className="account__element__saleslist__label">
                            User
                        </div>
                        <div className="account__element__saleslist__label">
                            Earnings
                        </div>

                        {(this.state.sales && this.state.sales.length >= 1) &&
                            this.state.sales.map((sale, i) => (
                                sale && sale.order && (
                                    <React.Fragment key={sale.creator_credit_id}>
                                        <div className="account__element__saleslist__value">
                                            {sale.creator_credit_id}
                                        </div>
                                        <div className="account__element__saleslist__value">
                                            {format_date(sale.created, true, true)}
                                        </div>
                                        <Link to={"/trip/" + sale.order.trip_id} className="account__element__saleslist__value">
                                            {sale.order.label}
                                        </Link>
                                        {sale.order.buyer_username &&
                                            <Link to={"/u/" + sale.order.buyer_username} className="account__element__saleslist__value">
                                                {sale.order.buyer_username}
                                            </Link>
                                        }
                                        {!sale.order.buyer_username &&
                                            <div className="account__element__saleslist__value">
                                                Not available
                                            </div>
                                        }
                                        <div className="account__element__saleslist__value">
                                            {sale.amount_net && format_price(parseFloat(sale.amount_net))}
                                        </div>
                                    </React.Fragment>
                                )
                            ))
                        }

                        {!(this.state.sales && this.state.sales.length >= 1) &&
                            <div className="account__element__saleslist__value account__element__saleslist__value--all-columns">
                                No sales available
                            </div>
                        }

                    </div>
                }

                {this.state.view === "payouts" &&
                    <div className="account__element account__element__payoutlist">
                        <div className="account__element__payoutlist__label">
                            ID
                        </div>
                        <div className="account__element__payoutlist__label">
                            Date
                        </div>
                        <div className="account__element__payoutlist__label">
                            Amount
                        </div>

                        {(this.state.payouts && this.state.payouts.length >= 1) &&
                            this.state.payouts.map((payout, i) => (
                                payout && (
                                    <React.Fragment key={payout.creator_payout_id}>
                                        <div className="account__element__saleslist__value">
                                            {payout.creator_payout_id}
                                        </div>
                                        <div className="account__element__saleslist__value">
                                            {payout.created && format_date(payout.created, true, true)}
                                        </div>
                                        <div className="account__element__saleslist__value">
                                            {payout.amount && format_price(parseFloat(payout.amount))}
                                        </div>
                                    </React.Fragment>
                                )
                            ))
                        }
                        {!(this.state.payouts && this.state.payouts.length >= 1) &&
                            <div className="account__element__payoutlist__value account__element__payoutlist__value--all-columns">
                                No payouts available
                            </div>
                        }

                    </div>
                }

            </div>
        )
    }
}